import angular from 'angular';
import referralDetails from './referralDetails';
import './style.scss';

export default angular
  .module('scenes.referral.scenes.referralDetails', [])
  .component('referralDetails', referralDetails).name;
